import createRootReducer, { MobileRootState } from './root-reducer';
import { createConfigureStore } from '../../configure-store';

export default createConfigureStore<MobileRootState>({
  createRootReducer,
  createRootReducerPath: require.resolve('./root-reducer'),
});
